/** leads/filterBus.ts — 벤처기업 탭 현재 필터를 셸(야간 토글)과 공유하는 초경량 버스 */
let current: { region?: string; sigungu?: string } = {};
export function setCandidateFilters(f: { region?: string; sigungu?: string }): void { current = f; }
export function getCandidateFilters(): { region?: string; sigungu?: string } { return current; }
